import { render } from "./TheNotificationsArea.vue?vue&type=template&id=2945dcde&scoped=true"
import script from "./TheNotificationsArea.vue?vue&type=script&lang=js"
export * from "./TheNotificationsArea.vue?vue&type=script&lang=js"

import "./TheNotificationsArea.vue?vue&type=style&index=0&id=2945dcde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2945dcde"

export default script